// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U6sS3_y6PUP6YP {
  width: 100%;
  margin-bottom: var(--ds-space-400, 32px);
}
._3mZErDDuUJnlp0 {
  display: flex;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px) var(--ds-space-100, 8px) var(--ds-space-200, 15px);
  border-radius: var(--ds-border-radius-100, 3px);
  background: var(--ds-background-information, #e9f2ff);
}
.H3P1NhusyXRUib {
  padding: var(--ds-space-250, 21px) var(--ds-space-200, 15px) var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border-information, #1d7afc);
}
.H3P1NhusyXRUib tr:last-child {
  border-bottom: none;
}
.WTZ_M7BL8loGaN {
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 13px;
  text-decoration: underline;
}
.WTZ_M7BL8loGaN:hover {
  cursor: pointer;
}
.DyEEbG3BmkGcY4 {
  margin-top: var(--ds-space-150, 12px);
  margin-right: var(--ds-space-075, 6px);
}
.JrxrrEhK6wlk_D {
  margin-top: var(--ds-space-150, 12px);
  margin-right: var(--ds-space-100, 8px);
  padding-top: var(--ds-space-0, 0);
}
.M4KaZE2zW8qXrg {
  display: flex;
  flex-wrap: wrap;
  padding-top: var(--ds-space-025, 2px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `U6sS3_y6PUP6YP`,
	"summary": `_3mZErDDuUJnlp0`,
	"details": `H3P1NhusyXRUib`,
	"link": `WTZ_M7BL8loGaN`,
	"text": `DyEEbG3BmkGcY4`,
	"icon": `JrxrrEhK6wlk_D`,
	"label": `M4KaZE2zW8qXrg`
};
export default ___CSS_LOADER_EXPORT___;
